import type { Fields } from '../../types';
import { FieldTypes } from '../../types/fieldTypes';
import { intensityOptions as options } from './options';

// https://www.gdsuite.it/laravel/v1/visita/data?pk_id_pt=37392&pk_id_vt=26030&group=200
export const step2: Fields = [
  {
    code: 201,
    name: 'Dermatite atopica',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 202,
    name: 'Insonnia',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 203,
    name: 'Cistiti',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 204,
    name: 'Candida',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 205,
    name: 'Calcoli renali',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 206,
    name: 'Fegato grasso',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 207,
    name: 'Gastrite',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 208,
    name: 'Colite Ulcerosa',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 209,
    name: 'Reflusso gastro-esofageo',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 210,
    name: 'Colon irritabile',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 211,
    name: 'Ipertensione arteriosa',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 212,
    name: 'Ipertiroidismo',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 213,
    name: 'Ipotiroidismo',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
  {
    code: 214,
    name: 'Osteoporosi',
    type: FieldTypes.radio,
    options,
    group: 200,
  },
];
